module.exports = __webpack_public_path__ + "img/subscricao.327e54b1.png";